(function (global, factory) {
  global.DatePicker = factory();
})(this, function () {
  /**
   * Constructor function for creating a Date Picker component.
   *
   * @constructor
   * @returns {DatePicker}
   */
  function DatePicker() {
    this.parentEle = null;
    this.input = null;

    this.build();
  }

  /**
   * Builds the DatePicker component HTML
   *
   * @function
   */
  DatePicker.prototype.build = function () {
    // INPUT WRAP
    this.parentEle = _DOM.createElement('div', {
      class: 'datePicker',
    });

    // INPUT & LABEL
    this.input = _DOM.createElement('input', {
      id: 'datePicker',
      type: 'date',
      name: 'datePicker',
    });
    const labelEle = _DOM.createElement('label', {
      node: Icon.getIcon('calendar'),
      for: 'datePicker',
    });
    labelEle.addEventListener('click', e => {
      this.input.showPicker();
    });

    this.parentEle.appendChild(this.input);
    this.parentEle.appendChild(labelEle);
  };

  /**
   * On date change method
   *
   * @function
   * @param {Function} cbFunc Callback function to call
   */
  DatePicker.prototype.onDateChange = function (cbFunc) {
    this.input.addEventListener('change', e => {
      cbFunc(e.target.value);
    });
  };

  /**
   * Renders the built DatePicker element to the specified DOM node.
   *
   * @function
   * @param {Node} node DOM node to render the input to
   * @returns {DatePicker} Returns the current instances for chaining
   */
  DatePicker.prototype.renderTo = function (node) {
    if (node instanceof Node) {
      node.appendChild(this.parentEle);
    }

    return this;
  };

  return DatePicker;
});
